import { translateBrowse } from './redirects';

export function redirectSearchWithoutEntryInQueryToBrowser(nextState, replace) {
  // requesting search without a valid search entry is invalid, redirect to catalogue browsing root
  if (!nextState.location.query || !nextState.location.query.entry) {
    const { entry, ...queryWithoutEntry } = nextState.location.query;

    replace({
      ...nextState.location,
      pathname: '/browse',
      query: queryWithoutEntry,
    });

    return false;
  }

  return true;
}

export function redirectCatatalogueToBrowse(nextState, replace) {
  const tagsPath = nextState.params.tags.filter(Boolean).join('/');
  replace({
    ...nextState.location,
    pathname: `/browse${tagsPath ? `/${tagsPath}` : ''}`,
  });

  return false;
}

export function redirectUrlWithTagsInQuery(nextState, replace) {
  // requesting browse without a old link format, translate request to new format
  if (nextState.location.search.indexOf('tags') !== -1) {
    replace(translateBrowse('browse', nextState.location));

    return false;
  }

  return true;
}

